import * as React from 'react';

import CustomerProjectsNarrowDownForm from "./customer_projects_narrow_down_form";
import CustomerProjectsMain from "./customer_projects_main";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem, TPagination} from "../../../type/common";
import {Project} from "../../../../domain/model/project";
import {TCompanyWithProjectID} from "../../../../domain/repository/company_repository";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import EmptyData from "../../../common/organism/empty_data";
import {ProjectsEmpty} from "../../../../config/view_const/projects";
import CustomerProjectsSearchForm from "./customer_projects_search_form";
import CustomerProjectsOverlayNotice from "./customer_projects_overlay_notice";

import styled, {createGlobalStyle} from 'styled-components'
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import {Customer} from 'src/domain/model/customer';
import CustomerTutorialComponent from '../tutorial/customer_tutorial';
import CustomerProjectsSlick from "./customer_projects_slick";
import HeadlineSmall from "../../../common/atom/text/headline_small";
import Faq from "../../faq";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    customer: Customer | null;
    isActive: boolean;
    handleNextStep: () => void;
    isStatusInspection: boolean
    projects: Project[];
    projectCount: number;
    companiesWithProjectID: TCompanyWithProjectID[];
    newlyArrivedProjects: Project[];
    companiesWithNewlyArrivedProjectID: TCompanyWithProjectID[];
    entryNumOrderProjects: Project[];
    companiesWithEntryNumOrderProjectID: TCompanyWithProjectID[];
    searchFormInitValues: {
        q: string,
        occupation: number,
        workingHourRange: number,
        paymentRange: number,
        workingDuration: number
    };
    paginationPrams: TPagination;
    handleSearch: (values: any) => void;
    handleOccupationChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handleWorkingHourRangeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handlePaymentRangeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handleWorkingDurationChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CustomerProjectsComponent: React.FC<IProps> = (props) => {
    const {
        isInit, isLoading, projects, projectCount, companiesWithProjectID,
        customer,
        isActive,
        handleNextStep,
        searchFormInitValues,
        paginationPrams,
        handleSearch,
        isStatusInspection,
        handleOccupationChange,
        handleWorkingHourRangeChange,
        handlePaymentRangeChange,
        handleWorkingDurationChange,
        newlyArrivedProjects,
        companiesWithNewlyArrivedProjectID,
        entryNumOrderProjects,
        companiesWithEntryNumOrderProjectID
    } = props;

    // 初期化
    if (isInit) {
        return <Progress canAnimation={false}/>
    }

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.customerRoot,
        routeConfig.customerProjects,
    ]

    return (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}

            {!isActive
                ?
                <CustomerTutorialComponent
                    customer={customer}
                    handleNextStep={handleNextStep}
                />
                :
                <PageWrapper>
                    <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                    {/*<PageTopInfo*/}
                    {/*    information={pageTopInfoConfig.customerProject}*/}
                    {/*    linkURL={OuterURL.customerProjectFaqURL}*/}
                    {/*/>*/}
                    <Faq title={"エントリーもしくはスカウト後のアクションについて"}
                         text={"新規案件が登録されるとお知らせタブに通知が届き、企業からスカウトを受けた場合は担当者と直接やり取りができるメッセージルームが開設されます。"}
                         link={
                             "https://branch-saturn-9ef.notion.site/178b91fe393e80b8a79ac5e2870a9583"
                         }/>
                    {isStatusInspection && (
                        <React.Fragment>
                            <PreventScrollStyle/>
                            <CustomerProjectsOverlayNotice/>
                        </React.Fragment>
                    )}

                    <CustomerProjectsSearchForm onSubmit={handleSearch} initialValues={searchFormInitValues}/>
                    <CustomerProjectsNarrowDownForm
                        onSubmit={handleSearch}
                        handleOccupationChange={handleOccupationChange}
                        handleWorkingHourRangeChange={handleWorkingHourRangeChange}
                        handlePaymentRangeChange={handlePaymentRangeChange}
                        handleWorkingDurationChange={handleWorkingDurationChange}
                    />
                    {projectCount === 0 &&
                        <EmptyData
                            main={ProjectsEmpty.projectsForCustomerMain}
                            description={ProjectsEmpty.projectsForCustomerDescription}
                        />
                    }
                    {projectCount > 0 &&
                        <CustomerProjectsMain
                            projects={projects}
                            companiesWithProjectID={companiesWithProjectID}
                            isLoading={isLoading}
                            paginationPrams={paginationPrams}
                        />
                    }
                    <SubTitleWrapper>
                        <HeadlineSmall>
                            新着
                        </HeadlineSmall>
                    </SubTitleWrapper>
                    <CustomerProjectsSlick projects={newlyArrivedProjects}
                                           companiesWithProjectID={companiesWithNewlyArrivedProjectID}/>

                    <SubTitleWrapper>
                        <HeadlineSmall>
                            おすすめ
                        </HeadlineSmall>
                    </SubTitleWrapper>
                    <CustomerProjectsSlick projects={entryNumOrderProjects}
                                           companiesWithProjectID={companiesWithEntryNumOrderProjectID}/>

                </PageWrapper>
            }
        </React.Fragment>
    )

};

export default CustomerProjectsComponent;

const PreventScrollStyle = createGlobalStyle`
    body {
        overflow-y: hidden;
    }`;

const SubTitleWrapper = styled.div`
    margin-bottom: 15px;
`


// WEBPACK FOOTER //
// ./src/presentation/component/customer/projects/customer_projects.tsx